import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAppInternalTransitionFunc = func => ({
  type: actionTypes.SET_APP_INTERNAL_TRANSITION_FUNC,
  payload: func
})
